// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `audio-player audio {
  position: absolute;
  opacity: 0;
  top: -300px;
  left: -300px;
  pointer-events: none;
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/motes-media-player/audio-player/audio-player.component.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,kBAAA;AADR","sourcesContent":["audio-player {\n\n    audio {\n        position: absolute;\n        opacity: 0;\n        top: -300px;\n        left: -300px;\n        pointer-events: none;\n        visibility: hidden;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
